import React from 'react';
import { PipelineStage } from '../callCenterAllTicketsTypes';
import styles from './TicketStatusPipeline.module.css';

interface TicketStatusPipelineProps {
  current: PipelineStage;
}

const stages: PipelineStage[] = ['Open', 'Assigned', 'In Progress', 'Resolved', 'Closed'];

export const TicketStatusPipeline: React.FC<TicketStatusPipelineProps> = ({ current }) => {
  const currentIdx = stages.indexOf(current);

  return (
    <div className={styles.pipeline}>
      {stages.map((stage, idx) => {
        const isCompleted = idx < currentIdx;
        const isActive = idx === currentIdx;
        const stateClass = isActive ? styles.active : isCompleted ? styles.completed : styles.pending;

        return (
          <React.Fragment key={stage}>
            <div className={styles.step}>
              <span className={`${styles.dot} ${stateClass}`}>
                {isCompleted ? '✓' : ''}
              </span>
              <span className={`${styles.label} ${stateClass}`}>{stage}</span>
            </div>
            {idx < stages.length - 1 && (
              <span className={`${styles.line} ${idx < currentIdx ? styles.lineCompleted : ''}`} />
            )}
          </React.Fragment>
        );
      })}
    </div>
  );
};
